<template>
  <div id="contenedor-infraestructura-listado-configuracion-tipos-infraestructura">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop :listadoTiposInfraestructura="listadoTiposInfraestructura"> </desktop>
    </template>
    <template v-else>
      <desktop :listadoTiposInfraestructura="listadoTiposInfraestructura"></desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'InfraestructuraListadoConfiguracionTipoInfraestructura',
  props: {
    listadoTiposInfraestructura: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss"></style>
